import { type CountryFieldValidationsResponse } from 'country-configuration/types/FieldValidations.type'

import { FormFieldNames, RegistrySumbitErrors } from '../constants/form'
import type { FormErrors } from '../types/form'
import type { RegistryErrors } from '../types/registry'

// TODO: refactor to object-pattern oriented
export const mapRegistryErrorsToFormErrors = (
	registryErrors: NonNullable<RegistryErrors>,
	{
		fieldsConfiguration,
	}: { fieldsConfiguration: CountryFieldValidationsResponse }
) =>
	registryErrors.map(
		(errorField): { field: FormErrors; messageKey?: string } | null => {
			if (errorField === RegistrySumbitErrors.Email) {
				return {
					field: FormFieldNames.Email,
					messageKey: `form.${fieldsConfiguration.email.labelKey}.format.errormessage`,
				}
			}

			if (errorField === RegistrySumbitErrors.Password) {
				return {
					field: FormFieldNames.Password,
					messageKey: `form.${fieldsConfiguration.password.labelKey}.format.errormessage`,
				}
			}

			if (errorField === RegistrySumbitErrors.Mobile) {
				return {
					field: FormFieldNames.Phone,
				}
			}

			if (errorField === RegistrySumbitErrors.Generic) {
				return { field: 'root' }
			}

			return { field: 'root' }
		}
	)
